import Swiper from "swiper";
import '../../../js/vendors/fancybox/jquery.fancybox';

function showMediaSlider () {
    $( '[data-fancybox="fancybox-media-slider-item"]' ).fancybox( {
        baseClass: "fancybox-media-slider",
        hash: false,
        smallBtn : false,
        iframe : {
            preload : false
        }
    } );

    let swiperMediaSlider = new Swiper( '.c-media-slider__inner-container', {
        loop: true,
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: '.c-media-slider__pagination',
            clickable: true
        },
        navigation: {
            prevEl: '.c-media-slider__btn-prev',
            nextEl: '.c-media-slider__btn-next'
        }
    } );
}

export default showMediaSlider;
